<div class="dependent-modal">
  <div class="dependent-modal__body">
    <div class="dependent-modal__scroll" tabindex="0">
      <div class="dependent-modal__col">
        <div class="dependent-modal__title">Source Document Value</div>
        <hr class="dependent-modal__divider" />
        <markdown class="dependent-modal__content ai-answer-markdown" [data]="sourceValue">{{sourceValue || '--'}}</markdown>
      </div>
      <div class="dependent-modal__col">
        <div class="dependent-modal__title">Tape Value</div>
        <hr class="dependent-modal__divider" />
        <markdown class="dependent-modal__content ai-answer-markdown" [data]="tapeValue">{{tapeValue || '--'}}</markdown>
      </div>
    </div>
  </div>
  <div class="dependent-modal__actions">
    <button mat-button (click)="onClose()">Close</button>
  </div>
</div>
